import {ApiV0Contracting} from '../api.v0.contracting';
import {RestApiService} from '../../../rest-api.service';
import {DeviceInfoReq, DeviceInfoRes} from '../../../../contracts/v0/contracting/device-info';
import {Observable} from 'rxjs';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';

export class ApiV0DeviceInfo {
    segment: string;

    constructor(v0: ApiV0Contracting, public rest: RestApiService) {
        this.segment = v0.segment + '/device';
    }

    getDevices():Observable<BaseCollectionModel<DeviceInfoRes>>{
        return this.rest.get<BaseCollectionModel<DeviceInfoRes>>(`${this.segment}`, DeviceInfoRes);
    }

    createDevice(createReq: DeviceInfoReq): Observable<DeviceInfoRes> {
        return this.rest.post<DeviceInfoReq, DeviceInfoRes>(`${this.segment}`, DeviceInfoRes, createReq)
    }

    searchDevices(searchReq: SearchModel = new SearchModel({})): Observable<BaseCollectionModel<DeviceInfoRes>>{
        return this.rest.post<SearchModel, BaseCollectionModel<DeviceInfoRes>>(`${this.segment}/search`, DeviceInfoRes, searchReq)
    }
}